import { render, staticRenderFns } from "./ParkingBarriersTimeline.vue?vue&type=template&id=472a0f7c"
import script from "./ParkingBarriersTimeline.vue?vue&type=script&lang=js"
export * from "./ParkingBarriersTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports